import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextArea } from 'src/components/shared/form/formik/FormikTextArea'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { LmsTrainingFormMode, LmsTrainingFormValues } from './LmsTrainingForm.interface'

const OPTIONAL_FIELDS_HINT =
  'Optional fields can be updated but not cleared — the admin API ignores empty values.'

interface Props {
  mode: LmsTrainingFormMode
}

const LmsTrainingFormContentComponent = ({ mode }: Props) => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <FormikTextField<LmsTrainingFormValues>
        name="externalId"
        label="External ID"
        placeholder="e.g. 1001"
      />
      <FormikTextField<LmsTrainingFormValues>
        name="url"
        label="URL"
        placeholder="https://lms.gigsafe.co/…"
      />
      <FormikTextField<LmsTrainingFormValues>
        name="title"
        label="Title"
        placeholder="e.g. Defensive Driving 101"
      />
      {/* BasicTextArea does not set fullWidth the way BasicTextField does, so pass it here. */}
      <FormikTextArea<LmsTrainingFormValues>
        name="description"
        label="Description"
        placeholder="What the course covers"
        minRows={3}
        fullWidth
      />
      <FormikTextArea<LmsTrainingFormValues>
        name="manualUploadRequirements"
        label="Manual upload requirements"
        placeholder="What a contractor must upload if completing this course manually"
        minRows={3}
        fullWidth
      />
      {mode === 'edit' ? (
        <Typography variant="body2" css={tw`text-shades-500`}>
          {OPTIONAL_FIELDS_HINT}
        </Typography>
      ) : null}
    </div>
  )
}

export const LmsTrainingFormContent = memo(LmsTrainingFormContentComponent)
